package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{TestRunSearchData, TestRunView, TestSessionProperties}
import com.neurobs.ccab.db.StudyTypeData
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelController, AdminPanelDelegate}
import com.neurobs.js.dom.{ElementFactory, InputTextBox, SelectSelectBox}
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.view.Container
import org.scalajs.dom.raw.Event
import scalatags.JsDom.all._
import com.neurobs.js.dom.Grid._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.util.StringUtilities

import scala.concurrent.ExecutionContext.Implicits.global
import scala.concurrent.{Future, Promise}

class TestRunErrorController(recordCache: RecordCache) extends AdminPanelController {

	private val panel: PanelView = {
		val temp = new PanelView(title = s"Test Run Errors", showRefresh = false, fullWidth = true)
		val closeButton = ElementFactory.makeLink(text = "Close")
		closeButton.onclick = (_:Event) => delegate.foreach(_.close())
		temp.setRightCorner(closeButton)

		val studyTypeBox: SelectSelectBox = ElementFactory.makeSelectBox(width = 20)
		var studyTypes = Seq[StudyTypeData]()
		recordCache.studyTypes.get.map(_.foreach { types =>
			studyTypes = types
			studyTypeBox.setOptions(types.map(_.displayName))
		})

		val box: InputTextBox = ElementFactory.makeTextInput(width = 30)
		box.setValue("Exited for reason: Performance Failure")
		val perfLink = ElementFactory.makeLink(text = "Performance")
		perfLink.onclick = (_) => { box.setValue("Exited for reason: Performance Failure") }
		val cancelledLink = ElementFactory.makeLink(text = "Cancelled")
		cancelledLink.onclick = (_) => { box.setValue("The test was cancelled.") }


		val button = ElementFactory.makeButton(caption = "Search")
		button.onclick = (e: Event) => {
			if (box.value().isEmpty) box.setValue("[Enter an error]")
			else studyTypeBox.selectedIndex match {
				case Some(typeIndex) =>
					if (typeIndex < studyTypes.length) {
						val studyType = studyTypes(typeIndex)
						val search = TestRunSearchData(studyTypeId = studyType.id, runError = box.value())
						delegate.foreach(_.newPanel(TestRunErrorListController(search, studyType.displayName)))
					}
				case None =>
			}
		}

		temp.grid.addRow(div("Study Type: ", studyTypeBox.select).render)
		temp.grid.addRow(div("Error: ", box.text, " ", perfLink, " ", cancelledLink).render)
		temp.grid.addRow(div(button).render)

		temp
	}

	override def container: Container = panel.container
}

class TestRunErrorListController(search: TestRunSearchData, studyTypeName: String) extends AdminListAdapter[TestRunView] {

	override def title = s"Test Failures '${search.runError}' for study type '$studyTypeName'"

	override def itemName = "Test Run"

	override def columnHeaders = Seq(
		"Account",
		"Study",
		"Reporting ID",
		"Born",
		"Subject GUID",
		"Start Time",
		"Test",
		"",
		"Properties"
	)

	override def itemRow(run: TestRunView, delegate: Option[AdminPanelDelegate], controller: AdminListController[TestRunView]) = {

		val logfileLink = ElementFactory.makeLink(text = "log")
		logfileLink.href = s"/api/v1/test_runs/${run.testRunId}/logfile"
		logfileLink.target = "_blank"
		Seq(
			run.primaryEmail,
			run.studyDisplayName,
			run.reportingId.toString,
			run.birthYear.map(_.toString).getOrElse(""): String,
			run.subjectGuid.toString,
			StringUtilities.dateTimeString(run.startTime),
			run.testDisplayName,
			logfileLink,
			TestSessionProperties.fromJson(run.sessionProperties.getOrElse("")).map(_.terseSummary).getOrElse(""): String
		)
	}

	override val create = None

	override def get(): Future[Either[String, Seq[TestRunView]]] = {
		val promise = Promise[Either[String, Seq[TestRunView]]]
		CCABServer.getErrorTestRuns(search) {
			case Left(e) => promise.success(Left(e.message))
			case Right(runs) =>
				val sorted =
					for (
						account <- runs.view.groupBy(_.accountId);
						study <- account._2.view.groupBy(_.studyId);
						subject <- study._2.view.groupBy(_.accountSubjectId);
						run <- subject._2.view.sortBy(_.startTime.instant.getEpochSecond)
					) yield run
				promise.success(Right(sorted.toVector))
		}
		promise.future
	}
}

object TestRunErrorListController {
	def apply(search: TestRunSearchData, studyTypeName: String) = new AdminListController[TestRunView](new TestRunErrorListController(search, studyTypeName))
}
